import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-background px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl border border-amber-900/10 bg-white/80 p-9 shadow-xl shadow-amber-900/10 backdrop-blur">
        <Logo />
        <h1 className="mt-8 font-display text-3xl font-bold text-emerald-950" data-testid="admin-login-heading">
          Admin Login
        </h1>
        <p className="mt-1 text-sm text-emerald-950/60">Manage stations, menu and orders.</p>
        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            data-testid="admin-email-input"
            className="h-12 w-full rounded-2xl border border-emerald-900/15 bg-transparent px-4 font-semibold focus:outline-none focus:ring-2 focus:ring-amber-500"
          />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            data-testid="admin-password-input"
            className="h-12 w-full rounded-2xl border border-emerald-900/15 bg-transparent px-4 font-semibold focus:outline-none focus:ring-2 focus:ring-amber-500"
          />
          {error && (
            <p className="rounded-xl bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-700" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full bg-emerald-900 py-3.5 text-base font-bold text-amber-50 transition-colors hover:bg-emerald-800 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" className="mt-5 block text-center text-sm font-semibold text-amber-700 hover:underline" data-testid="back-to-site-link">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
